import { normalizeString } from '@utils/functions/normalizeString'
import { WEEKDAY_MAP } from '../context/types'

export const getDay = (label: string) => {
  const dayMatch = label.match(/Qtd\.\s*([^(]+)\s*\(/i)

  if (!dayMatch) return ''

  const normalized = normalizeString(dayMatch[1])

  return WEEKDAY_MAP[normalized] ?? ''
}
